import { render, staticRenderFns } from "./Sedentos.vue?vue&type=template&id=3fdd6a0c&scoped=true"
import script from "./Sedentos.vue?vue&type=script&lang=js"
export * from "./Sedentos.vue?vue&type=script&lang=js"
import style0 from "./Sedentos.vue?vue&type=style&index=0&id=3fdd6a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd6a0c",
  null
  
)

export default component.exports